import { RejectedMessage } from 'componets/ui';
import { NotFoundLayout } from 'componets/layouts';

import { useAppSelector } from 'hooks';
export const NotFound = () => {
	const user = useAppSelector((state) => state.user.entity);

	return (
		<NotFoundLayout email={user.email}>
			<RejectedMessage isNotFound />
		</NotFoundLayout>
	);
};
